import {
  Box,
  Divider,
  Icon,
  Modal,
  Typography,
  Card,
  TextField,
  FormHelperText,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Snackbar,
  Alert,
  AlertTitle,
  Grid,
  Tooltip,
  IconButton,
  InputAdornment,
} from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import SemesterSelector from '../components/SemesterSelector';
import { useState, useEffect } from "react";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

export function ParticipantUpdate({
  open,
  handleClose,
  onSubmit,
  participant,
  handleAlert = () => { },
  gendersList = [],
  specialProtectionGroupsList = [],
}) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "800px",
    maxHeight: "95vh",
    borderRadius: "20px",
    boxShadow: 24,
    p: 4,
  };

  const defaultValues = {
    document: "",
    name: "",
    last_name: "",
    state: "",
    gender: "",
    location: "",
    academic_program: "",
    semester: "",
    special_protection_group: "",
    email: "",
    phone: "",
    emergency_phone: "",
  };

  const [formValues, setFormValues] = useState(defaultValues);
  const [errors, setErrors] = useState(defaultValues);
  const [snackbar, setSnackbar] = useState({ type: "", message: "", open: false });

  useEffect(() => {
    if (participant) {
      console.log(participant)
      const newFormValues = {
        document: participant.document || "",
        name: participant.name || "",
        last_name: participant.last_name || "",
        state: participant.state || "",
        gender: typeof participant.gender === 'object' ? participant.gender?.name || "" : participant.gender || "",
        location: participant.location || "",
        academic_program: participant.academic_program || "",
        semester: participant.semester || "",
        email: participant.email || "",
        phone: participant.phone || "",
        emergency_phone: participant.emergency_phone || "",
        special_protection_group: typeof participant.special_protection_group === 'object' ? participant.special_protection_group?.name || "" : participant.special_protection_group || "",
      };

      setFormValues(newFormValues);

      console.log(newFormValues.gender.id);
      console.log(gendersList);
      // Validar todos los campos cuando el modal se abre con datos existentes
      let newErrors = {};
      Object.keys(newFormValues).forEach((key) => {
        // Saltar validación para special_protection_group ya que es opcional
        if (key === "special_protection_group") {
          newErrors[key] = { message: "", error: false };
        } else {
          newErrors[key] = validationFields(key, newFormValues[key])
            ? { message: "", error: false }
            : { message: "Valor inválido", error: true };
        }
      });

      setErrors(newErrors);
      console.log(formValues);
    } else {
      setFormValues(defaultValues);
      setErrors(defaultValues);
    }
  }, [participant, open]);

  const capitalizeFirstLetter = (input) => {
    if (input === null || input === undefined) return input;
    return String(input).toUpperCase();
  };

  const handleChange = (event, type) => {
    const { name, value } = event.target;

    if (type != "select" && (name === "name" || name === "last_name")) {
      const input = event.target;
      const cursorPosition = input.selectionStart;
      const transformed = capitalizeFirstLetter(value);

      validationFields(name, transformed);
      setFormValues({
        ...formValues,
        [name]: transformed,
      });

      // Restaurar posición del cursor inmediatamente después
      Promise.resolve().then(() => {
        input.setSelectionRange(cursorPosition, cursorPosition);
      });
    } else {
      validationFields(name, value);
      setFormValues({
        ...formValues,
        [name]: value,
      });
    }
  };

  const validationFields = (fieldName, value) => {
    let isValidField = true;
    let newErrors = { ...errors };

    if (value == undefined || value == null || value == "") {
      // Permitir que campos opcionales sean vacíos (emergency_phone ya NO es opcional)
      if (fieldName === "special_protection_group" || fieldName === "semester" || fieldName === "academic_program" || fieldName === "phone") {
        isValidField = true;
        newErrors[fieldName] = { message: "", error: false };
      } else {
        isValidField = false;
        newErrors[fieldName] = {
          message: "El campo es requerido",
          error: true,
        };
      }
    } else {
      if (fieldName === "document") {
        if (!/^\d+$/.test(value)) {
          isValidField = false;
          newErrors[fieldName] = {
            message: "El campo debe ser numérico",
            error: true,
          };
        }
      } else if (fieldName == "name" || fieldName == "last_name") {
        if (!/^[A-Za-zÀ-ÿ0-9\s'\-\.]{1,100}$/.test(value)) {
          isValidField = false;
          newErrors[fieldName] = {
            message: "Solo se permiten letras, números, espacios, tildes, apóstrofes, guiones y puntos",
            error: true,
          };
        }
      } else if (fieldName == "academic_program") {
        if (!/^[a-zA-ZñÑáéíóúÁÉÍÓÚüÜ\s'\-\.]{2,100}$/.test(value)) {
          isValidField = false;
          newErrors[fieldName] = {
            message: "Solo se permiten letras, espacios, tildes, apóstrofes, guiones y puntos",
            error: true,
          };
        }
      } else if (fieldName == "semester") {
        // Campo opcional, validar que ambos (año y período) estén llenos o ambos vacíos
        if (value) {
          const parts = value.split('-');
          const hasYear = parts[0] && parts[0].trim() !== '';
          const hasPeriod = parts[1] && parts[1].trim() !== '';

          if (hasYear && !hasPeriod) {
            isValidField = false;
            newErrors[fieldName] = {
              message: "Debe seleccionar el período",
              error: true,
            };
          } else if (!hasYear && hasPeriod) {
            isValidField = false;
            newErrors[fieldName] = {
              message: "Debe seleccionar el año",
              error: true,
            };
          } else if (hasYear && hasPeriod && !/^\d{4}-[12]$/.test(value)) {
            isValidField = false;
            newErrors[fieldName] = {
              message: "Formato requerido: YYYY-N (ej: 2025-1)",
              error: true,
            };
          } else {
            isValidField = true;
            newErrors[fieldName] = { message: "", error: false };
          }
        } else {
          isValidField = true;
          newErrors[fieldName] = { message: "", error: false };
        }
      } else if (fieldName == "location") {
        if (!/^[a-zA-ZÀ-ÿ\s\u00f1\u00d1\d\-,.#]+$/.test(value)) {
          isValidField = false;
          newErrors[fieldName] = {
            message: "No se permiten caracteres especiales",
            error: true,
          };
        }
      } else if (fieldName == "state") {
        if (!/^[a-zA-ZÀ-ÿ\s\u00f1\u00d1,]+$/.test(value)) {
          isValidField = false;
          newErrors[fieldName] = {
            message: "No se permiten caracteres especiales",
            error: true,
          };
        }
      } else if (fieldName == "gender") {
        // Campo de selección, solo validar que no esté vacío
        newErrors[fieldName] = { message: "", error: false };
      } else if (fieldName === "email") {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          isValidField = false;
          newErrors[fieldName] = {
            message: "Formato de email inválido",
            error: true,
          };
        }
      } else if (fieldName === "phone" || fieldName === "emergency_phone") {
        // Validación para números de teléfono internacionales (solo dígitos y longitud mínima)
        if (value && !/^\d+$/.test(value)) {
          isValidField = false;
          newErrors[fieldName] = {
            message: "Formato de teléfono inválido",
            error: true,
          };
        } else if (value && value.length < 10) {
          isValidField = false;
          newErrors[fieldName] = {
            message: "El número de teléfono debe tener al menos 10 dígitos",
            error: true,
          };
        }
      }

      if (isValidField) {
        newErrors[fieldName] = { message: "", error: false };
      }
    }

    setErrors(newErrors);
    return isValidField;
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    let isValidForm = true;
    let newErrors = { ...errors };

    for (let formValue in formValues) {
      // Saltar validación para campos opcionales (emergency_phone ya NO es opcional)
      if (formValue === "special_protection_group" || (formValue === "semester" && !formValues[formValue]) || (formValue === "academic_program" && !formValues[formValue]) || (formValue === "phone" && !formValues[formValue])) {
        continue;
      }
      const isValidField = validationFields(formValue, formValues[formValue]);
      if (!isValidField) {
        isValidForm = false;
      }
    }

    if (isValidForm && !Object.values(newErrors).some((error) => error.error)) {
      try {
        await onSubmit({ ...formValues, id: participant.id });
        setSnackbar({ type: "success", message: "Participante actualizado con éxito", open: true });
        handleClose();
      } catch (error) {
        setSnackbar({ type: "error", message: "Error al actualizar el participante", open: true });
      }
    } else {
      handleAlert("fail", "Hay al menos un error en los campos ingresados");
      return;
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Card sx={style}>
          <MDBox
            mt={-7}
            color="white"
            bgColor="info"
            variant="gradient"
            borderRadius="lg"
            p={2}
            sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Typography id="modal-modal-title" component="h2">
              {participant ? "Editar participante" : "Crear participante"}
            </Typography>
            <Icon
              sx={{
                fontSize: "2em",
                stroke: "currentColor",
                strokeWidth: "2px",
                cursor: "pointer",
                marginLeft: "auto",
              }}
              onClick={handleClose}>
              close
            </Icon>
          </MDBox>
          <Divider variant="middle" />
          <Box sx={{ padding: "24px", maxHeight: "65vh", overflowY: "auto" }}>
            <Box component="form" onSubmit={handleFormSubmit} sx={{ mt: 0 }}>
              <Grid container spacing={2.5}>
                {/* Cédula y Género */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Cédula o Identificación *"
                    variant="outlined"
                    name="document"
                    value={formValues.document}
                    onChange={handleChange}
                    error={errors && errors.document?.error}
                    helperText={errors && errors.document?.message}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl
                    fullWidth
                    error={errors && errors.gender?.error}
                  >
                    <InputLabel id="select-gender-label">Género *</InputLabel>
                    <Select
                      labelId="select-gender-label"
                      id="select-gender"
                      value={formValues.gender || ""}
                      label="Género *"
                      name="gender"
                      onChange={(event) => handleChange(event, "select")}
                      sx={{ minHeight: 44 }}
                    >
                      <MenuItem value="">
                        <em>Seleccione...</em>
                      </MenuItem>
                      {gendersList.map((gender) => (
                        <MenuItem key={gender.id} value={gender.name}>
                          {gender.name}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>{errors && errors.gender?.message}</FormHelperText>
                  </FormControl>
                </Grid>

                {/* Nombre y Apellido */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Nombre *"
                    variant="outlined"
                    name="name"
                    value={formValues.name}
                    onChange={handleChange}
                    error={errors && errors.name?.error}
                    helperText={errors && errors.name?.message}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Apellido *"
                    variant="outlined"
                    name="last_name"
                    value={formValues.last_name}
                    onChange={handleChange}
                    error={errors && errors.last_name?.error}
                    helperText={errors && errors.last_name?.message}
                  />
                </Grid>

                {/* Estado y Ubicación */}
                <Grid item xs={12} md={6}>
                  <FormControl
                    fullWidth
                    error={errors && errors.state?.error}
                  >
                    <InputLabel id="select-state-label">Estado *</InputLabel>
                    <Select
                      labelId="select-state-label"
                      id="select-state"
                      value={formValues.state}
                      label="Estado *"
                      name="state"
                      onChange={(event) => handleChange(event, "select")}
                      sx={{ minHeight: 44 }}
                    >
                      <MenuItem value="">
                        <em>Seleccione...</em>
                      </MenuItem>
                      <MenuItem value="Académico">Académico</MenuItem>
                      <MenuItem value="Laboral">Laboral</MenuItem>
                    </Select>
                    <FormHelperText>{errors && errors.state?.message}</FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Ubicación Geográfica *"
                    variant="outlined"
                    name="location"
                    value={formValues.location}
                    onChange={handleChange}
                    error={errors && errors.location?.error}
                    helperText={errors && errors.location?.message}
                  />
                </Grid>

                {/* Programa Académico y Semestre */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Programa Académico"
                    variant="outlined"
                    name="academic_program"
                    value={formValues.academic_program}
                    onChange={handleChange}
                    error={errors && errors.academic_program?.error}
                    helperText={errors && errors.academic_program?.message}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <SemesterSelector
                    value={formValues.semester}
                    onChange={(value) => handleChange({ target: { name: 'semester', value } })}
                    error={errors && errors.semester?.error}
                    helperText={errors && errors.semester?.message}
                    required={false}
                    labelPrefix="update-"
                  />
                </Grid>

                {/* Población vulnerable y Correo */}
                <Grid item xs={12} md={6}>
                  <FormControl
                    fullWidth
                    error={errors && errors.special_protection_group?.error}
                  >
                    <InputLabel id="select-special-protection-label">Población vulnerable</InputLabel>
                    <Select
                      labelId="select-special-protection-label"
                      id="select-special-protection"
                      value={formValues.special_protection_group || ""}
                      label="Población vulnerable"
                      name="special_protection_group"
                      onChange={(event) => handleChange(event, "select")}
                      sx={{ minHeight: 44 }}
                      endAdornment={
                        formValues.special_protection_group && (
                          <InputAdornment position="end" sx={{ mr: 4 }}>
                            <Tooltip
                              title={specialProtectionGroupsList.find(group => group.name === formValues.special_protection_group)?.description || ""}
                              arrow
                            >
                              <IconButton size="small">
                                <HelpOutlineIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </InputAdornment>
                        )
                      }
                    >
                      <MenuItem value="">
                        <em>Ninguno</em>
                      </MenuItem>
                      {specialProtectionGroupsList.map((group) => (
                        <MenuItem key={group.id} value={group.name}>
                          {group.name}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>{errors && errors.special_protection_group?.message}</FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Correo Electrónico"
                    variant="outlined"
                    name="email"
                    type="email"
                    value={formValues.email}
                    onChange={handleChange}
                    error={errors && errors.email?.error}
                    helperText={errors && errors.email?.message}
                  />
                </Grid>

                {/* Teléfonos */}
                <Grid item xs={12} md={6}>
                  <Box sx={{
                    '& .special-label': {
                      fontSize: '0.75rem',
                      color: 'rgba(43, 39, 39, 0.6)',
                      fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                      fontWeight: 400,
                    },
                    '& .react-tel-input .form-control': {
                      fontSize: '1rem !important',
                      fontFamily: '"Roboto","Helvetica","Arial",sans-serif !important',
                      fontWeight: '400 !important',
                      color: 'rgba(39, 32, 32, 0.87) !important',
                      letterSpacing: '0.00938em !important',
                      borderWidth: '1px !important',
                    },
                    '& .react-tel-input .flag-dropdown': {
                      borderWidth: '1px !important',
                    }
                  }}>
                    <PhoneInput
                      country={'co'}
                      value={formValues.phone}
                      onChange={(value) => handleChange({ target: { name: 'phone', value } })}
                      inputProps={{
                        name: 'phone',
                        required: false,
                      }}
                      containerStyle={{
                        width: '100%',
                      }}
                      inputStyle={{
                        width: '100%',
                        height: '56px',
                        fontSize: '1rem',
                        fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                        fontWeight: 400,
                        lineHeight: '1.4375em',
                        letterSpacing: '0.00938em',
                        color: 'rgba(0, 0, 0, 0.87)',
                        borderRadius: '4px',
                        border: '1px solid',
                        borderColor: errors && errors.phone?.error ? '#d32f2f' : 'rgba(0, 0, 0, 0.23)',
                        paddingLeft: '60px',
                      }}
                      buttonStyle={{
                        border: '1px solid',
                        borderColor: errors && errors.phone?.error ? '#d32f2f' : 'rgba(0, 0, 0, 0.23)',
                        borderRadius: '4px 0 0 4px',
                        backgroundColor: 'transparent',
                        borderRight: 'none',
                      }}
                      dropdownStyle={{
                        fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                        fontSize: '1rem',
                      }}
                      specialLabel="Celular"
                      enableSearch={true}
                      searchPlaceholder="Buscar país"
                      disableSearchIcon={false}
                    />
                    {errors && errors.phone?.error && (
                      <FormHelperText error sx={{ ml: 2, fontFamily: '"Roboto","Helvetica","Arial",sans-serif' }}>
                        {errors.phone.message}
                      </FormHelperText>
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box sx={{
                    '& .special-label': {
                      fontSize: '0.75rem',
                      color: 'rgba(0, 0, 0, 0.6)',
                      fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                      fontWeight: 400,
                    },
                    '& .react-tel-input .form-control': {
                      fontSize: '1rem !important',
                      fontFamily: '"Roboto","Helvetica","Arial",sans-serif !important',
                      fontWeight: '400 !important',
                      color: 'rgba(0, 0, 0, 0.87) !important',
                      letterSpacing: '0.00938em !important',
                      borderWidth: '1px !important',
                    },
                    '& .react-tel-input .flag-dropdown': {
                      borderWidth: '1px !important',
                    }
                  }}>
                    <PhoneInput
                      country={'co'}
                      value={formValues.emergency_phone}
                      onChange={(value) => handleChange({ target: { name: 'emergency_phone', value } })}
                      inputProps={{
                        name: 'emergency_phone',
                        required: false,
                      }}
                      containerStyle={{
                        width: '100%',
                      }}
                      inputStyle={{
                        width: '100%',
                        height: '56px',
                        fontSize: '1rem',
                        fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                        fontWeight: 400,
                        lineHeight: '1.4375em',
                        letterSpacing: '0.00938em',
                        color: 'rgba(0, 0, 0, 0.87)',
                        borderRadius: '4px',
                        border: '1px solid',
                        borderColor: errors && errors.emergency_phone?.error ? '#d32f2f' : 'rgba(0, 0, 0, 0.23)',
                        paddingLeft: '60px',
                      }}
                      buttonStyle={{
                        border: '1px solid',
                        borderColor: errors && errors.emergency_phone?.error ? '#d32f2f' : 'rgba(0, 0, 0, 0.23)',
                        borderRadius: '4px 0 0 4px',
                        backgroundColor: 'transparent',
                        borderRight: 'none',
                      }}
                      dropdownStyle={{
                        fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                        fontSize: '1rem',
                      }}
                      specialLabel="Teléfono de Emergencia *"
                      enableSearch={true}
                      searchPlaceholder="Buscar país"
                      disableSearchIcon={false}
                    />
                    {errors && errors.emergency_phone?.error && (
                      <FormHelperText error sx={{ ml: 2, fontFamily: '"Roboto","Helvetica","Arial",sans-serif' }}>
                        {errors.emergency_phone.message}
                      </FormHelperText>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Divider variant="middle" />
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
            <MDButton
              color="error"
              sx={{
                flex: 1,
                mr: 1,
              }}
              onClick={handleClose}>
              Cancelar
            </MDButton>
            <MDButton
              onClick={handleFormSubmit}
              color="success"
              sx={{
                flex: 1,
                ml: 1,
              }}>
              {participant ? "Actualizar" : "Crear"}
            </MDButton>
          </Box>
        </Card>
      </Modal>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000} // Duración en ms
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }} // Ubicación
        key={snackbar.type} // Asegúrate de usar una clave única
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.type || "info"} sx={{ width: "100%" }}>
          <AlertTitle>
            {snackbar.type === "success" ? "La solicitud se hizo correctamente " : "Error"}
          </AlertTitle>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}
